import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/b2cSettings', request)
}

async function post(request) {
    return await postMethod('/api/b2cSettings', request)
}

async function put(b2cId, request) {
    return await putMethod(`/api/b2cSettings/${b2cId}`, request)
}

export {get, post, put}
